import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'
import { responsiveImageFragment } from '../fragments/images'

export const istitutoPage = gql`
  ${seoFragment}
  ${responsiveImageFragment}
  query IstitutoPage($locale: SiteLocale) {
    paginaIstituto(locale: $locale) {
      seo {
        ...SeoFragment
      }
      titolo
      slug
      intro {
        titolo
        primaColonna
        secondaColonna
        immagineDecorativa {
          titolo
          immagine {
            responsiveImage(imgixParams: { fm: webp, q: "50" }) {
              ...ResponsiveImageFragment
            }
          }
        }
        parolaTarget
        titolo
        cta {
          testo
          link
          file {
            url
          }
        }
      }
      sezioneDoppiaColonna1 {
        id
        primaColonna
        secondaColonna
        sottotitolo
        titolo
        immagineDecorativa {
          titolo
          immagine {
            responsiveImage(imgixParams: { fm: webp, q: "50" }) {
              ...ResponsiveImageFragment
            }
          }
        }
        parolaTarget
        cta {
          testo
          link
          file {
            url
          }
        }
      }
      sezioneImmagineTesto {
        titolo
        immagineADestra
        immagineDecorativa {
          titolo
          immagine {
            responsiveImage(imgixParams: { fm: webp, q: "50" }) {
              ...ResponsiveImageFragment
            }
          }
        }
        testo
        landscape: immagine {
          responsiveImage(imgixParams: { fm: webp, q: "50" }) {
            ...ResponsiveImageFragment
          }
        }
        portrait: immagine {
          responsiveImage(
            imgixParams: { auto: compress, q: "50", ar: "1:1", fit: crop }
          ) {
            ...ResponsiveImageFragment
          }
        }
        cta {
          testo
          link
          file {
            url
          }
        }
      }
      sezioneDoppiaColonna2 {
        id
        primaColonna
        secondaColonna
        sottotitolo
        titolo
        immagineDecorativa {
          titolo
          immagine {
            responsiveImage(imgixParams: { fm: webp, q: "50" }) {
              ...ResponsiveImageFragment
            }
          }
        }
        parolaTarget
        cta {
          testo
          link
          file {
            url
          }
        }
      }
      recensioni {
        titolo
        sottotitolo
        immagineDecorativa {
          titolo
          immagine {
            responsiveImage(imgixParams: { fm: webp, q: "50" }) {
              ...ResponsiveImageFragment
            }
          }
        }
        parolaTarget
        bloccoRecensione {
          testo
          autore
          id
        }
      }
      preFooter {
        contenuto {
          titolo
          primaColonna
          secondaColonna
          immagineDecorativa {
            titolo
            immagine {
              responsiveImage(imgixParams: { fm: webp, q: "50" }) {
                ...ResponsiveImageFragment
              }
            }
          }
        }
        coloreSfondo {
          hex
        }
      }
    }
  }
`
